<app-confirm-dialog
  *ngIf="!(dontAskMeAgainChecked$ | async)"
  [dialogId]="dialogType"
  [removeIdPrefix]="true"
  [confirmTitle]="'DIALOG.CONVERT_TO_INVOICE.TITLE' | translate"
  [confirmPrompt]="'DIALOG.CONVERT_TO_INVOICE.PROMPT' | translate"
  [cancelText]="'DIALOG.CONVERT_TO_INVOICE.CANCEL' | translate"
  [yesText]="'DIALOG.CONVERT_TO_INVOICE.YES_CONVERT' | translate"
  [trackingScreenName]="trackingScreenName"
  [trackingDialogName]="convertToInvoiceDialogName"
  [primaryActionTapped]="convertToInvoicePrimaryTapped"
  [secondaryActionTapped]="convertToInvoiceSecondaryTapped"
  (onClose)="convertToInvoice($event)"
>
  <app-checkbox-field
    class="dont-ask-me-again"
    fieldId="dont_ask_me_again_field"
    [label]="'DIALOG.CONVERT_TO_INVOICE.DONT_ASK_ME_AGAIN' | translate"
    [fieldControl]="dontAskMeAgainControl"
  >
  </app-checkbox-field>
</app-confirm-dialog>
